/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, centerAbsolutely, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CALLOUTS INDICATOR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	callouts: {
		display: 'flex',
		justifyContent: 'center',
		flexWrap: 'wrap'
	}
};